/* ============================================================
   AY ATHLETICS — MAIN JS
   Whole, undivided.
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ── CUSTOM CURSOR — mouse/trackpad only ───────────────────
  if (window.matchMedia('(pointer: fine)').matches) {
    const cursor = document.getElementById('cursor');
    const ring   = document.getElementById('cursorRing');

    if (cursor && ring) {
      let mx = 0, my = 0, rx = 0, ry = 0;

      document.addEventListener('mousemove', e => {
        mx = e.clientX; my = e.clientY;
        cursor.style.left = mx + 'px';
        cursor.style.top  = my + 'px';
      });

      const animateRing = () => {
        rx += (mx - rx) * 0.1;
        ry += (my - ry) * 0.1;
        ring.style.left = rx + 'px';
        ring.style.top  = ry + 'px';
        requestAnimationFrame(animateRing);
      };
      animateRing();

      document.querySelectorAll('a, button, .ay-product-tile, select, input').forEach(el => {
        el.addEventListener('mouseenter', () => {
          cursor.classList.add('cursor--hover');
          ring.classList.add('cursor-ring--hover');
        });
        el.addEventListener('mouseleave', () => {
          cursor.classList.remove('cursor--hover');
          ring.classList.remove('cursor-ring--hover');
        });
      });

      // Invert cursor color on dark sections
      const darkSections = document.querySelectorAll(
        '.ay-section--dark, .ay-product-page__preorder, .ay-product-page__construction, .ay-cart__summary, .ay-preorder__form'
      );
      darkSections.forEach(section => {
        section.addEventListener('mouseenter', () => {
          cursor.classList.add('cursor--inv');
          ring.classList.add('cursor-ring--inv');
        });
        section.addEventListener('mouseleave', () => {
          cursor.classList.remove('cursor--inv');
          ring.classList.remove('cursor-ring--inv');
        });
      });
    }
  }

  // ── HEADER SCROLL STATE ────────────────────────────────────
  const header = document.getElementById('AyHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('ay-header--scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ── MOBILE MENU ────────────────────────────────────────────
  const toggle  = document.getElementById('MobileMenuToggle');
  const menu    = document.getElementById('MobileMenu');
  const close   = document.getElementById('MobileMenuClose');
  const overlay = document.getElementById('MobileMenuOverlay');

  const openMenu  = () => {
    menu?.classList.add('is-open');
    overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  const closeMenu = () => {
    menu?.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  toggle?.addEventListener('click', openMenu);
  close?.addEventListener('click', closeMenu);
  overlay?.addEventListener('click', closeMenu);

  // ── SCROLL REVEAL ──────────────────────────────────────────
  const revealElements = document.querySelectorAll(
    '.ay-product-tile, .ay-philosophy__item, .ay-name-block, .ay-statement__content'
  );

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    revealElements.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = `opacity 0.6s ease ${i * 0.08}s, transform 0.6s ease ${i * 0.08}s`;
      revealObserver.observe(el);
    });
  }

  // ── PREORDER FORM FEEDBACK ─────────────────────────────────
  const preorderForm = document.querySelector('.ay-preorder__form');
  if (preorderForm) {
    preorderForm.addEventListener('submit', e => {
      const btn = preorderForm.querySelector('[type="submit"]');
      if (btn) {
        btn.textContent = 'Reserving…';
        btn.disabled = true;
      }
    });
  }

  // ── SMOOTH ANCHOR LINKS ────────────────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', e => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

});